import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createClinicPackage = createAsyncThunk(
    "clinicPackageMaster/createClinicPackage",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/clinicPackageMaster/createClinicPackage", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const updateClinicPackage = createAsyncThunk(
    "clinicPackageMaster/updateClinicPackage",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/clinicPackageMaster/updateClinicPackage", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const deleteClinicPackage = createAsyncThunk(
    "clinicPackageMaster/deleteClinicPackage",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/clinicPackageMaster/deleteClinicPackage", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getClinicPackage = createAsyncThunk(
    "clinicPackageMaster/getClinicPackage",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/clinicPackageMaster/getClinicPackage", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getClinicPackageById = createAsyncThunk(
    "clinicPackageMaster/getClinicPackageById",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/clinicPackageMaster/getClinicPackageById", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

const initialState = {
    loading: false,
    clinicPackageMaster: [],
    clinicPackageMasterById: [],
    createClinicPackageSuccessMessage: null,
    createClinicPackageErrorMessage: null,
    updateClinicPackageSuccessMessage: null,
    updateClinicPackageErrorMessage: null,
    deleteClinicPackageSuccessMessage: null,
    deleteClinicPackageErrorMessage: null
}
const cliniPackageMasterSlice = createSlice({
    name: "clinicPackageMaster",
    initialState,
    reducers: {
        resetUpdateClinicPackageMessage: (state) => {
            state.updateClinicPackageSuccessMessage = null;
            state.updateClinicPackageErrorMessage = null;
        },
        resetDeleteClinicPackageMessage: (state) => {
            state.deleteClinicPackageSuccessMessage = null;
            state.deleteClinicPackageErrorMessage = null;
        },
        resetCreateClinicPackageMessage: (state) => {
            state.createClinicPackageSuccessMessage = null;
            state.createClinicPackageErrorMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createClinicPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(createClinicPackage.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.createClinicPackageErrorMessage = action.payload.result.message;
                } else {
                    state.createClinicPackageSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(createClinicPackage.rejected, (state, action) => {
                state.loading = false;
                state.createClinicPackageErrorMessage = action.payload.result.message;
            })
            .addCase(updateClinicPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateClinicPackage.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.updateClinicPackageErrorMessage = action.payload.result.message;
                } else {
                    state.updateClinicPackageSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(updateClinicPackage.rejected, (state, action) => {
                state.loading = false;
                state.updateClinicPackageErrorMessage = action.payload.result.message;
            })
            .addCase(deleteClinicPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteClinicPackage.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.deleteClinicPackageErrorMessage = action.payload.result.message;
                } else {
                    state.deleteClinicPackageSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(deleteClinicPackage.rejected, (state, action) => {
                state.loading = false;
                state.deleteClinicPackageErrorMessage = action.payload.result.message;
            })
            .addCase(getClinicPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(getClinicPackage.fulfilled, (state, action) => {
                state.loading = false;
                state.clinicPackageMaster = action.payload.result.list;
            })
            .addCase(getClinicPackage.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(getClinicPackageById.pending, (state) => {
                state.loading = true;
            })
            .addCase(getClinicPackageById.fulfilled, (state, action) => {
                state.loading = false;
                state.clinicPackageMasterById = action.payload.result.list;
            })
            .addCase(getClinicPackageById.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export const {
    resetCreateClinicPackageMessage,
    resetUpdateClinicPackageMessage,
    resetDeleteClinicPackageMessage,
} = cliniPackageMasterSlice.actions;

export default cliniPackageMasterSlice.reducer;